function formatEnumLabel(value) {
    return value
        .split('_')
        .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
        .join(' ');
}
const TRIP_STAGES = [
    'DREAMING', 'DECIDING', 'BOOKING', 'TRAVEL_READY', 'TRAVELING', 'REMEMBERING',
];
export function getTripStageLabel(stage) {
    return formatEnumLabel(stage);
}
export const TRIP_STAGE_OPTIONS = TRIP_STAGES.map((value) => ({ value, label: formatEnumLabel(value) }));
